import {
  CurrencyRupee,
  Facebook,
  Instagram,
  Interests,
  LinkedIn,
  Telegram,
  Twitter,
  WhatsApp,
  YouTube,
} from "@mui/icons-material";
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Button,
  Chip,
  Grid,
  Box,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import paymentdashboardservice from "../../../services/paymentdashboardservice";
import LatestCampaignSkelton from "../../../CustomSkelton/LatestCampaignSkelton";

export default function CampaignsList({ loading, campaigns }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const PlatformIconByName = {
    Instagram: <Instagram color="error" fontSize="small" />,
    Youtube: <YouTube color="error" fontSize="small" />,
    Twitter: <Twitter color="error" fontSize="small" />,
    Facebook: <Facebook color="error" fontSize="small" />,
    WhatsApp: <WhatsApp color="error" fontSize="small" />,
    LinkedIn: <LinkedIn color="error" fontSize="small" />,
    Telegram: <Telegram color="error" fontSize="small" />,
    Other: <Interests color="error" fontSize="small" />,
  };

  return (
    <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box sx={{ width: "100%", overflowX: "auto" }}>
            {loading ? (
              <LatestCampaignSkelton />
            ) : campaigns.length > 0 ? (
              <List
                sx={{
                  bgcolor: "background.paper",
                  width: "100%",
                }}
                subheader={
                  <ListSubheader
                    sx={{
                      fontSize: "1.3rem",
                      color: "black",
                      position: "relative",
                      lineHeight: isMobile ? 1.2 : 1.5,
                    }}
                    id="nested-list-subheader"
                  >
                    Latest Campaigns
                  </ListSubheader>
                }
              >
                <Divider />
                {campaigns.map((d, index) => (
                  <React.Fragment key={index}>
                    <ListItem
                      alignItems="flex-start"
                      sx={{
                        cursor: "pointer",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "flex-start" : "center",
                        px: isMobile ? 1 : 2,
                        py: isMobile ? 1.5 : 1,
                      }}
                      onClick={() => navigate(`/payments/campaigns/details/${d._id}`)}
                    >
                      <ListItemText
                        sx={{
                          margin: isMobile ? 0 : undefined,
                        }}
                        primary={
                          <div
                            style={{
                              display: "flex",
                              fontSize: "9px",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: isMobile ? "4px" : "0px",
                            }}
                          >
                            {
                              PlatformIconByName[
                              d.platform.map((platform) => platform.name)
                              ]
                            }
                            <span style={{ margin: "0 4px" }}>|</span>
                            <Chip
                              label={d.name}
                              size="small"
                              sx={{
                                fontSize: "10px",
                                maxWidth: isMobile ? "120px" : "none",
                              }}
                            />
                            {/* <span style={{ margin: "0 4px" }}>|</span> */}
                          </div>
                        }
                        primaryTypographyProps={{
                          variant: "overline",
                          component: "div",
                        }}
                        secondary={
                          <>
                            <Box
                              sx={{
                                whiteSpace: isMobile ? "normal" : "nowrap",
                              }}
                            >
                              <b>
                                <CurrencyRupee fontSize="" />
                                {d.totalPayment} |
                              </b>
                              <span
                                style={{
                                  whiteSpace: isMobile ? "normal" : "nowrap",
                                  wordBreak: isMobile ? "break-word" : "normal",
                                }}
                              >
                                {d.user.map((user) => user)}
                              </span>
                              {/* | {d.paymentLimit} */}
                              {/* <Typography>
                                {new Date(
                                  d.createdAt,
                                ).toLocaleDateString("en-GB")}
                              </Typography> */}
                            </Box>
                          </>
                        }
                        secondaryTypographyProps={{
                          variant: "overline",
                          component: "div",
                        }}
                      />
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))}
                <ListItem
                  sx={{
                    justifyContent: "center",
                    px: isMobile ? 1 : 2,
                  }}
                >
                  <Button
                    variant="outlined"
                    size={isMobile ? "small" : "small"}
                    onClick={() => navigate("/payments/campaigns")}
                    sx={{
                      width: isMobile ? "100%" : "auto",
                      minWidth: isMobile ? "auto" : "100px",
                    }}
                  >
                    View All
                  </Button>
                </ListItem>
              </List>
            ) : (
              <ListSubheader
                sx={{
                  fontSize: "1.5rem",
                  color: "red",
                  textAlign: "center",
                  width: "100%",
                }}
                id="nested-list-subheader"
              >
                No Campaigns
              </ListSubheader>
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
